module.exports = __webpack_public_path__ + "img/messenger.11b1e8bd.png";